import styles from './PerkButton.module.scss';

import React from 'react';
import cx from 'clsx';
import { Icon } from 'components/Icon';
import { useTranslation } from 'react-i18next';
import { useSmartNavigate } from 'hooks/useSmartNavigate';
import { PERK_BUTTON_TEST_ID } from './PerkButton.const';

type Props = {
  numAvailablePerks: number;
};

export const PerkButton: React.FC<Props> = ({ numAvailablePerks }: Props) => {
  const { t } = useTranslation();
  const navigate = useSmartNavigate();

  const handleClick = () => {
    navigate('~perks');
  };

  const hasAvailable = numAvailablePerks > 0;
  const buttonTextPath = hasAvailable
    ? 'perks.buttonAvailable'
    : 'perks.buttonInProgress';

  return (
    <button
      data-testid={PERK_BUTTON_TEST_ID}
      onClick={handleClick}
      className={cx(styles.perkButton)}
    >
      <Icon className={styles.perkIcon} name={'trophy'} />
      <div className={cx(styles.perkTextContainer)}>
        {t(buttonTextPath, { count: numAvailablePerks })}
      </div>
    </button>
  );
};
